(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5005,4506],{

/***/ 16863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5 13H16.17L11.29 17.88C10.9 18.27 10.9 18.91 11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L12.71 4.7C12.32 4.31 11.69 4.31 11.3 4.7C10.91 5.09 10.91 5.72 11.3 6.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48732);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);


var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var isUserRejected = function(err) {
    // provider user rejected error code
    return typeof err === "object" && "code" in err && err.code === 4001;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ }),

/***/ 48629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WinSection_Home2; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46587);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(75275);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 9 modules
var Alert = __webpack_require__(69661);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(16863);
// EXTERNAL MODULE: ./node_modules/@metaplex-foundation/js/dist/esm/Metaplex.mjs + 207 modules
var Metaplex = __webpack_require__(26427);
// EXTERNAL MODULE: ./node_modules/@metaplex-foundation/js/dist/esm/plugins/walletAdapterIdentity/plugin.mjs + 1 modules
var walletAdapterIdentity_plugin = __webpack_require__(21267);
// EXTERNAL MODULE: ./node_modules/@metaplex-foundation/js/dist/esm/plugins/candyMachineModule/operations/mintFromCandyMachine.mjs
var mintFromCandyMachine = __webpack_require__(36838);
// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-react/lib/esm/useConnection.js
var useConnection = __webpack_require__(44718);
// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-react/lib/esm/useWallet.js
var useWallet = __webpack_require__(54306);
// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-react-ui/lib/esm/WalletMultiButton.js + 2 modules
var WalletMultiButton = __webpack_require__(58455);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js
var index_browser_esm = __webpack_require__(59917);
// EXTERNAL MODULE: ./node_modules/bn.js/lib/bn.js
var bn = __webpack_require__(13550);
var bn_default = /*#__PURE__*/__webpack_require__.n(bn);
// EXTERNAL MODULE: ./node_modules/canvas-confetti/dist/confetti.module.mjs
var confetti_module = __webpack_require__(39883);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./src/components/AppBar/Styles.module.css
var Styles_module = __webpack_require__(18746);
var Styles_module_default = /*#__PURE__*/__webpack_require__.n(Styles_module);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/views/Home/components/WinSection/mintCounter.ts
var mintCounter = __webpack_require__(41748);
// EXTERNAL MODULE: ./node_modules/@civic/solana-gateway-react/dist/esm/index.js
var esm = __webpack_require__(23975);
// EXTERNAL MODULE: ./src/views/Home/components/WinSection/config.ts
var config = __webpack_require__(24500);
// EXTERNAL MODULE: ./src/views/Home/components/WinSection/MultiMintButton.tsx
var MultiMintButton = __webpack_require__(8106);
// EXTERNAL MODULE: ./src/views/Home/components/WinSection/styles.ts
var styles = __webpack_require__(69269);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 11 modules
var Dialog = __webpack_require__(16028);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(66856);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContentText/DialogContentText.js
var DialogContentText = __webpack_require__(7212);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(66083);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardActionArea/CardActionArea.js
var CardActionArea = __webpack_require__(89738);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardActions/CardActions.js
var CardActions = __webpack_require__(51907);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardMedia/CardMedia.js
var CardMedia = __webpack_require__(951);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/NftsModal3.tsx
// @ts-nocheck

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 1.2em;\n  padding: 15px 20px;\n  font-weight: bold;\n  line-height: 0.5px;\n  color: #000;\n  background: #fff;\n  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),\n    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);\n  border: 0;\n  border-radius: 5px;\n  box-sizing: border-box;\n  font-family: "Patrick Hand", cursive;\n  vertical-align: middle;\n  transition: all linear 0.3s;\n\n  :hover {\n    border: none;\n    outline: none !important;\n    background: #d09a69;\n  }\n  :not(disabled) {\n    cursor: pointer;\n  }\n\n  :not(disabled):hover {\n    outline: 1px solid var(--title-text-color);\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var Action = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-76f4f943-0"
})(_templateObject());
function NftsModal3(param) {
    var mintedItems = param.mintedItems, setMintedItems = param.setMintedItems, openOnSolscan = param.openOnSolscan;
    var handleClose = function() {
        setMintedItems([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: !!mintedItems.length,
        keepMounted: true,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-slide-title",
        "aria-describedby": "alert-dialog-slide-description",
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                id: "alert-dialog-slide-title",
                children: "Nfts you had just minted!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                    id: "alert-dialog-slide-description",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        children: mintedItems.map(function(nft, key) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xl: 20,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea/* default */.Z, {
                                            children: [
                                                nft.json.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                                                    component: "video",
                                                    // component="img"
                                                    //   alt="Contemplative Reptile"
                                                    height: "500",
                                                    //image={'https://i.ibb.co/FJzZq42/Key-Gold-18-Jan23.png'}
                                                    src: "https://card-keys.unlimitedcope.com/2/webm",
                                                    // src={'https://giant.gfycat.com/SecondhandComplicatedAcornwoodpecker.mp4'}
                                                    autoPlay: true,
                                                    muted: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                                    children: [
                                                        nft.json.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            gutterBottom: true,
                                                            variant: "h5",
                                                            component: "h2",
                                                            children: nft.json.name
                                                        }),
                                                        nft.json.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            color: "textSecondary",
                                                            component: "p",
                                                            children: nft.json.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                                    children: (ref = nft.json.attributes) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                                        var trait_type = param.trait_type, value = param.value;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                            label: "".concat(trait_type, ": ").concat(value),
                                                            variant: "outlined",
                                                            style: {
                                                                margin: 2
                                                            }
                                                        }, trait_type);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                                style: {
                                                    width: "100%"
                                                },
                                                onClick: function() {
                                                    return openOnSolscan(nft.address.toString());
                                                },
                                                children: "View on solscan"
                                            })
                                        })
                                    ]
                                })
                            }, key);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                    onClick: handleClose,
                    children: "Close"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-base/lib/esm/types.js
var types = __webpack_require__(16247);
;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/Home2.tsx
/* provided dependency */ var process = __webpack_require__(34155);





function Home2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    Home2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: right;\n  margin: 30px;\n  z-index: 999;\n  position: relative;\n\n  .wallet-adapter-dropdown-list {\n    background: #ffffff;\n  }\n  .wallet-adapter-dropdown-list-item {\n    background: #000000;\n  }\n  .wallet-adapter-dropdown-list {\n    grid-row-gap: 5px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: black;\n  width: auto;\n  padding: 5px 5px 5px 16px;\n  min-width: 48px;\n  min-height: auto;\n  border-radius: 5px;\n  background-color: #85b1e2;\n  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),\n    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);\n  box-sizing: border-box;\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-weight: 500;\n  line-height: 1.75;\n  text-transform: uppercase;\n  border: 0;\n  margin: 0;\n  display: inline-flex;\n  outline: 0;\n  position: relative;\n  align-items: center;\n  user-select: none;\n  vertical-align: middle;\n  justify-content: flex-start;\n  gap: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50px !important;\n  padding: 6px 16px;\n  background-color: #fff;\n  color: #000;\n  margin: 0 auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background-color: var(--countdown-background-color) !important;\n  margin: 5px;\n  min-width: 40px;\n  padding: 24px;\n  h1 {\n    margin: 0px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






















var Header = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9673e484-0"
})(Home2_templateObject());
var WalletContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9673e484-1"
})(_templateObject1());
var WalletAmount = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9673e484-2"
})(_templateObject2());
var Wallet = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-9673e484-3"
})(_templateObject3());
var ConnectButton = (0,styled_components_browser_esm["default"])(WalletMultiButton/* WalletMultiButton */.a).withConfig({
    componentId: "sc-9673e484-4"
})(_templateObject4());
var Home2_Card = (0,styled_components_browser_esm["default"])(Paper/* default */.Z).withConfig({
    componentId: "sc-9673e484-5"
})(_templateObject5());
var fake = (/* unused pure expression or super */ null && ([]));
var Home2 = function(props) {
    var throwConfetti = function throwConfetti() {
        (0,confetti_module/* default */.Z)({
            particleCount: 400,
            spread: 70,
            origin: {
                y: 0.6
            }
        });
        props.closeModal();
    };
    var displaySuccess = function displaySuccess() {
        var qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        var ref;
        if ((ref = guards.mintLimit) === null || ref === void 0 ? void 0 : ref.mintCounter) guards.mintLimit.mintCounter.count += qty;
        var remaining = itemsRemaining - qty;
        setItemsRemaining(remaining);
        // setIsSoldOut(remaining === 0);
        setItemsRedeemed(itemsRedeemed + qty);
        connection.getBalance(wallet.publicKey).then(function(balance) {
            setBalance(balance / index_browser_esm.LAMPORTS_PER_SOL);
        });
    // throwConfetti();
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var connection = (0,useConnection/* useConnection */.R)().connection;
    var ref16 = (0,react.useState)(null), candyMachine = ref16[0], setCandyMachine = ref16[1];
    var ref17 = (0,react.useState)(), balance = ref17[0], setBalance = ref17[1];
    var ref18 = (0,react.useState)(false), isMinting = ref18[0], setIsMinting = ref18[1]; // true when user got to press MINT
    var ref19 = (0,react.useState)(0), itemsAvailable = ref19[0], setItemsAvailable = ref19[1];
    var ref20 = (0,react.useState)(0), itemsRedeemed = ref20[0], setItemsRedeemed = ref20[1];
    var ref21 = (0,react.useState)(0), itemsRemaining = ref21[0], setItemsRemaining = ref21[1];
    var ref22 = (0,react.useState)(), mintedItems = ref22[0], setMintedItems = ref22[1];
    // Yet To Implement
    // const [isActive, setIsActive] = useState(false); // true when countdown completes or whitelisted
    // const [solanaExplorerLink, setSolanaExplorerLink] = useState<string>("");
    // const [isSoldOut, setIsSoldOut] = useState(false);
    // const [payWithSplToken, setPayWithSplToken] = useState(false);
    var ref23 = (0,react.useState)(0), price = ref23[0], setPrice = ref23[1];
    var ref24 = (0,react.useState)(), priceLabel = ref24[0], setPriceLabel = ref24[1];
    // const [whitelistPrice, setWhitelistPrice] = useState(0);
    // const [whitelistEnabled, setWhitelistEnabled] = useState(false);
    // const [isBurnToken, setIsBurnToken] = useState(false);
    // const [endDate, setEndDate] = useState<Date>();
    var ref25 = (0,react.useState)(0), whitelistTokenBalance = ref25[0], setWhitelistTokenBalance = ref25[1];
    var ref26 = (0,react.useState)(false), isEnded = ref26[0], setIsEnded = ref26[1];
    var ref27 = (0,react.useState)(false), isPresale = ref27[0], setIsPresale = ref27[1];
    var ref28 = (0,react.useState)(false), isWLOnly = ref28[0], setIsWLOnly = ref28[1];
    var ref29 = (0,react.useState)(), guards = ref29[0], setGuards = ref29[1];
    console.log("here are the guards");
    console.log(guards);
    console.log(candyMachine);
    var ref30 = (0,react.useState)({
        open: false,
        message: "",
        severity: undefined
    }), alertState = ref30[0], setAlertState = ref30[1];
    var wallet = (0,useWallet/* useWallet */.O)();
    var mx = (0,react.useMemo)(function() {
        return connection && Metaplex/* Metaplex.make */.I.make(connection);
    }, [
        connection
    ]);
    var openOnSolscan = (0,react.useCallback)(function(mint) {
        window.open("https://solscan.io/address/".concat(mint).concat([
            types/* WalletAdapterNetwork.Mainnet */.Q.Mainnet,
            types/* WalletAdapterNetwork.Testnet */.Q.Testnet
        ].includes(config/* network */.L5) ? "?cluster=".concat(config/* network */.L5) : ""));
    }, []);
    (0,react.useEffect)(function() {
        if (!mx || !(wallet === null || wallet === void 0 ? void 0 : wallet.publicKey)) return;
        mx.use((0,walletAdapterIdentity_plugin/* walletAdapterIdentity */.t)(wallet));
    // mx.rpc().sendAndConfirmTransaction(aa as any,{skipPreflight: true})
    }, [
        mx,
        wallet
    ]);
    var refreshCandyMachineState = function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var cndy;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!wallet) return [
                            2
                        ];
                        return [
                            4,
                            mx.candyMachines().findByAddress({
                                address: new index_browser_esm.PublicKey(props.candyMachineId)
                            })
                        ];
                    case 1:
                        cndy = _state.sent();
                        console.log(cndy);
                        setCandyMachine(cndy);
                        setItemsAvailable(cndy.itemsAvailable.toNumber());
                        setItemsRemaining(cndy.itemsRemaining.toNumber());
                        setItemsRedeemed(cndy.itemsMinted.toNumber());
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var renderGoLiveDateCounter = function(param) {
        var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Home2_Card, {
                    elevation: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: days
                        }),
                        "Days"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Home2_Card, {
                    elevation: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: hours
                        }),
                        "Hours"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Home2_Card, {
                    elevation: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: minutes
                        }),
                        "Mins"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Home2_Card, {
                    elevation: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: seconds
                        }),
                        "Secs"
                    ]
                })
            ]
        });
    };
    var startMint = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var quantityString, transactionBuilders, index, _, blockhash, transactions, signers, signedTransactions, _tmp, _tmp1, _i, signer, output, nfts, error, message;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        quantityString = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            13,
                            14,
                            15
                        ]);
                        console.log(quantityString, candyMachine);
                        if (!candyMachine) return [
                            2
                        ];
                        setIsMinting(true);
                        transactionBuilders = [];
                        index = 0;
                        _state.label = 2;
                    case 2:
                        if (!(index < quantityString)) return [
                            3,
                            5
                        ];
                        _ = transactionBuilders.push;
                        return [
                            4,
                            (0,mintFromCandyMachine/* mintFromCandyMachineBuilder */.Jq)(mx, {
                                candyMachine: candyMachine,
                                collectionUpdateAuthority: candyMachine.authorityAddress
                            })
                        ];
                    case 3:
                        _.apply(transactionBuilders, [
                            _state.sent()
                        ]);
                        _state.label = 4;
                    case 4:
                        index++;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            4,
                            mx.rpc().getLatestBlockhash()
                        ];
                    case 6:
                        blockhash = _state.sent();
                        transactions = transactionBuilders.map(function(t) {
                            return t.toTransaction(blockhash);
                        });
                        signers = {};
                        transactions.forEach(function(tx, i) {
                            tx.feePayer = wallet.publicKey;
                            tx.recentBlockhash = blockhash.blockhash;
                            transactionBuilders[i].getSigners().forEach(function(s) {
                                if ("signAllTransactions" in s) signers[s.publicKey.toString()] = s;
                                else if ("secretKey" in s) tx.partialSign(s);
                                else if ("_signer" in s) tx.partialSign(s._signer);
                            });
                        });
                        signedTransactions = transactions;
                        _tmp = [];
                        for(_tmp1 in signers)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 7;
                    case 7:
                        if (!(_i < _tmp.length)) return [
                            3,
                            10
                        ];
                        signer = _tmp[_i];
                        return [
                            4,
                            signers[signer].signAllTransactions(transactions)
                        ];
                    case 8:
                        signedTransactions = _state.sent();
                        _state.label = 9;
                    case 9:
                        _i++;
                        return [
                            3,
                            7
                        ];
                    case 10:
                        return [
                            4,
                            Promise.all(signedTransactions.map(function(tx, i) {
                                return mx.rpc().sendAndConfirmTransaction(tx, {
                                    commitment: "finalized"
                                }).then(function(tx) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tx), {
                                        context: transactionBuilders[i].getContext()
                                    });
                                });
                            }))
                        ];
                    case 11:
                        output = _state.sent();
                        return [
                            4,
                            Promise.all(output.map(function(param) {
                                var context = param.context;
                                return mx.nfts().findByMint({
                                    mintAddress: context.mintSigner.publicKey,
                                    tokenAddress: context.tokenAddress
                                });
                            }))
                        ];
                    case 12:
                        nfts = _state.sent();
                        setMintedItems(nfts);
                        // connection.sendRawTransaction
                        // update front-end amounts
                        displaySuccess(quantityString);
                        return [
                            3,
                            15
                        ];
                    case 13:
                        error = _state.sent();
                        console.error(error);
                        message = error.msg || "Minting failed! Please try again!";
                        if (!error.msg) {
                            if (!error.message) {
                                message = "Transaction Timeout! Please try again.";
                            } else if (error.message.indexOf("0x138")) {} else if (error.message.indexOf("0x137")) {
                                message = "SOLD OUT!";
                            } else if (error.message.indexOf("0x135")) {
                                message = "Insufficient funds to mint. Please fund your wallet.";
                            }
                        } else {
                            if (error.code === 311) {
                                message = "SOLD OUT!";
                            } else if (error.code === 312) {
                                message = "Minting period hasn't started yet.";
                            }
                        }
                        setAlertState({
                            open: true,
                            message: message,
                            severity: "error"
                        });
                        return [
                            3,
                            15
                        ];
                    case 14:
                        // refreshCandyMachineState();
                        setIsMinting(false);
                        return [
                            7
                        ];
                    case 15:
                        return [
                            2
                        ];
                }
            });
        });
        return function startMint() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var balance;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(wallet === null || wallet === void 0 ? void 0 : wallet.publicKey)) return [
                            3,
                            2
                        ];
                        console.log(wallet.publicKey.toString());
                        return [
                            4,
                            connection.getBalance(wallet.publicKey)
                        ];
                    case 1:
                        balance = _state.sent();
                        setBalance(balance / index_browser_esm.LAMPORTS_PER_SOL);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        wallet,
        connection
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, guardsLocal, _, _1, ref13, date, ref14, date1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!candyMachine) return [
                            2
                        ];
                        if (!(candyMachine === null || candyMachine === void 0 ? void 0 : (ref = candyMachine.candyGuard) === null || ref === void 0 ? void 0 : ref.address)) return [
                            3,
                            5
                        ];
                        guardsLocal = {
                            address: candyMachine === null || candyMachine === void 0 ? void 0 : candyMachine.candyGuard.address
                        };
                        if (!candyMachine.candyGuard.guards.mintLimit) return [
                            3,
                            4
                        ];
                        guardsLocal.mintLimit = {
                            settings: candyMachine.candyGuard.guards.mintLimit
                        };
                        if (!((wallet === null || wallet === void 0 ? void 0 : wallet.publicKey) && !guardsLocal.mintLimit.pda)) return [
                            3,
                            2
                        ];
                        _ = guardsLocal.mintLimit;
                        return [
                            4,
                            mx.candyMachines().pdas().mintLimitCounter({
                                candyGuard: candyMachine === null || candyMachine === void 0 ? void 0 : candyMachine.candyGuard.address,
                                id: candyMachine.candyGuard.guards.mintLimit.id,
                                candyMachine: candyMachine.address,
                                user: wallet.publicKey
                            })
                        ];
                    case 1:
                        _.pda = _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!guardsLocal.mintLimit.pda) return [
                            3,
                            4
                        ];
                        _1 = guardsLocal.mintLimit;
                        return [
                            4,
                            connection.getAccountInfo(guardsLocal.mintLimit.pda)
                        ];
                    case 3:
                        _1.accountInfo = _state.sent();
                        if (guardsLocal.mintLimit.accountInfo) // [guardsLocal.mintLimit.mintCounter] = MintCounter.fromAccountInfo(
                        //   guardsLocal.mintLimit.accountInfo
                        // );
                        guardsLocal.mintLimit.mintCounter = mintCounter/* MintCounterBorsh.fromBuffer */.s.fromBuffer(guardsLocal.mintLimit.accountInfo.data);
                        _state.label = 4;
                    case 4:
                        if (candyMachine === null || candyMachine === void 0 ? void 0 : (ref1 = candyMachine.candyGuard) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.guards) === null || ref2 === void 0 ? void 0 : ref2.startDate) {
                            ;
                            date = new Date((candyMachine === null || candyMachine === void 0 ? void 0 : (ref13 = candyMachine.candyGuard) === null || ref13 === void 0 ? void 0 : ref13.guards.startDate.date.toNumber()) * 1000);
                            if (date.getTime() > Date.now()) {
                                guardsLocal.goLiveDate = date;
                            } else {
                                guardsLocal.goLiveDate = null;
                            }
                        }
                        if (candyMachine === null || candyMachine === void 0 ? void 0 : (ref3 = candyMachine.candyGuard) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.guards) === null || ref4 === void 0 ? void 0 : ref4.endDate) {
                            ;
                            date1 = new Date((candyMachine === null || candyMachine === void 0 ? void 0 : (ref14 = candyMachine.candyGuard) === null || ref14 === void 0 ? void 0 : ref14.guards.endDate.date.toNumber()) * 1000);
                            guardsLocal.endTime = date1;
                        }
                        if (candyMachine === null || candyMachine === void 0 ? void 0 : (ref5 = candyMachine.candyGuard) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.guards) === null || ref6 === void 0 ? void 0 : ref6.solPayment) guardsLocal.payment = candyMachine === null || candyMachine === void 0 ? void 0 : (ref7 = candyMachine.candyGuard) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.guards) === null || ref8 === void 0 ? void 0 : ref8.solPayment.amount;
                        if (candyMachine === null || candyMachine === void 0 ? void 0 : (ref9 = candyMachine.candyGuard) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.guards) === null || ref10 === void 0 ? void 0 : ref10.tokenPayment) guardsLocal.payment = candyMachine === null || candyMachine === void 0 ? void 0 : (ref11 = candyMachine.candyGuard) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.guards) === null || ref12 === void 0 ? void 0 : ref12.tokenPayment.amount;
                        console.log(guardsLocal);
                        console.log("above is guardsLocal");
                        if (guardsLocal.payment) {
                            setPrice(guardsLocal.payment.basisPoints.div(new (bn_default())(guardsLocal.payment.currency.decimals).pow(new (bn_default())(10))).toNumber());
                            setPriceLabel(guardsLocal.payment.currency.symbol);
                        }
                        setGuards(guardsLocal);
                        console.log("here is the guardsLocal");
                        console.log(guardsLocal);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        wallet,
        candyMachine,
        balance,
        connection,
        mx
    ]);
    (0,react.useEffect)(function() {
        console.log({
            guards: guards
        });
    }, [
        guards
    ]);
    (0,react.useEffect)(refreshCandyMachineState, [
        wallet,
        props.candyMachineId,
        connection,
        isEnded,
        isPresale,
        mx
    ]);
    (0,react.useEffect)(function() {
        if ((mintedItems === null || mintedItems === void 0 ? void 0 : mintedItems.length) === 0) throwConfetti();
    }, [
        mintedItems
    ]);
    var gatekeeperNetwork = candyMachine === null || candyMachine === void 0 ? void 0 : (ref = candyMachine.candyGuard) === null || ref === void 0 ? void 0 : (ref1 = ref.guards) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gatekeeper) === null || ref2 === void 0 ? void 0 : ref2.network;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Root */.fC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Hero */.VM, {
                            children: (guards === null || guards === void 0 ? void 0 : guards.goLiveDate) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                date: guards === null || guards === void 0 ? void 0 : guards.goLiveDate,
                                renderer: renderGoLiveDateCounter,
                                onComplete: function() {
                                    refreshCandyMachineState();
                                }
                            }) : !(wallet === null || wallet === void 0 ? void 0 : wallet.publicKey) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WalletMultiButton/* WalletMultiButton */.a, {
                                className: (Styles_module_default())["wallet-adapter-new-button-spectator"],
                                children: [
                                    "  ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        bold: true,
                                        color: "invertedContrast",
                                        children: "Purchase COPE Card Key "
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        ml: "4px",
                                        color: "invertedContrast"
                                    }),
                                    "  "
                                ]
                            }) : !isWLOnly || whitelistTokenBalance > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !!itemsRemaining && (candyMachine === null || candyMachine === void 0 ? void 0 : (ref3 = candyMachine.candyGuard) === null || ref3 === void 0 ? void 0 : ref3.guards.gatekeeper) && wallet.publicKey && wallet.signTransaction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.GatewayProvider, {
                                        wallet: {
                                            publicKey: wallet.publicKey,
                                            //@ts-ignore
                                            signTransaction: wallet.signTransaction
                                        },
                                        gatekeeperNetwork: gatekeeperNetwork,
                                        clusterUrl: connection.rpcEndpoint,
                                        cluster: process.env.NEXT_PUBLIC_SOLANA_NETWORK || "devnet",
                                        options: {
                                            autoShowModal: false
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiMintButton/* MultiMintButton */.V, {
                                            candyMachine: candyMachine,
                                            gatekeeperNetwork: gatekeeperNetwork,
                                            isMinting: isMinting,
                                            setIsMinting: setIsMinting,
                                            isActive: !!itemsRemaining,
                                            isEnded: isEnded,
                                            isSoldOut: !itemsRemaining,
                                            limit: (guards === null || guards === void 0 ? void 0 : (ref4 = guards.mintLimit) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.settings) === null || ref5 === void 0 ? void 0 : ref5.limit) ? (guards === null || guards === void 0 ? void 0 : (ref6 = guards.mintLimit) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.settings) === null || ref7 === void 0 ? void 0 : ref7.limit) - ((guards === null || guards === void 0 ? void 0 : (ref8 = guards.mintLimit) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.mintCounter) === null || ref9 === void 0 ? void 0 : ref9.count) || 0) : 10,
                                            onMint: startMint,
                                            price: price,
                                            priceLabel: priceLabel
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiMintButton/* MultiMintButton */.V, {
                                        candyMachine: candyMachine,
                                        isMinting: isMinting,
                                        setIsMinting: setIsMinting,
                                        isActive: !!itemsRemaining,
                                        isEnded: isEnded,
                                        isSoldOut: !itemsRemaining,
                                        limit: (guards === null || guards === void 0 ? void 0 : (ref10 = guards.mintLimit) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.settings) === null || ref11 === void 0 ? void 0 : ref11.limit) ? (guards === null || guards === void 0 ? void 0 : (ref12 = guards.mintLimit) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.settings) === null || ref13 === void 0 ? void 0 : ref13.limit) - ((guards === null || guards === void 0 ? void 0 : (ref14 = guards.mintLimit) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.mintCounter) === null || ref15 === void 0 ? void 0 : ref15.count) || 0) : 10,
                                        onMint: startMint,
                                        price: price,
                                        priceLabel: priceLabel
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Mint is private."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NftsModal3, {
                            openOnSolscan: openOnSolscan,
                            mintedItems: mintedItems || [],
                            setMintedItems: setMintedItems
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: alertState.open,
                autoHideDuration: 6000,
                onClose: function() {
                    return setAlertState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, alertState), {
                        open: false
                    }));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    onClose: function() {
                        return setAlertState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, alertState), {
                            open: false
                        }));
                    },
                    severity: alertState.severity,
                    children: alertState.message
                })
            })
        ]
    });
};
/* harmony default export */ var WinSection_Home2 = (Home2);


/***/ }),

/***/ 8106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MultiMintButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69779);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46587);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95477);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23975);
/* harmony import */ var _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16863);
// @ts-nocheck








function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
var MultiMintButton = function(param) {
    var onMint = param.onMint, candyMachine = param.candyMachine, isMinting = param.isMinting, setIsMinting = param.setIsMinting, isEnded = param.isEnded, isActive = param.isActive, isSoldOut = param.isSoldOut, price = param.price, priceLabel = param.priceLabel, limit = param.limit, gatekeeperNetwork = param.gatekeeperNetwork;
    var incrementValue = function incrementValue() {
        var numericField = document.querySelector(".mint-qty");
        if (numericField) {
            var value = parseInt(numericField.value);
            if (!isNaN(value) && value < 10) {
                value++;
                numericField.value = "" + value;
                updateAmounts(value);
            }
        }
    };
    var decrementValue = function decrementValue() {
        var numericField = document.querySelector(".mint-qty");
        if (numericField) {
            var value = parseInt(numericField.value);
            if (!isNaN(value) && value > 1) {
                value--;
                numericField.value = "" + value;
                updateAmounts(value);
            }
        }
    };
    var updateMintCount = function updateMintCount(target) {
        var value = parseInt(target.value);
        if (!isNaN(value)) {
            if (value > 10) {
                value = 10;
                target.value = "" + value;
            } else if (value < 1) {
                value = 1;
                target.value = "" + value;
            }
            updateAmounts(value);
        }
    };
    var updateAmounts = function updateAmounts(qty) {
        setMintCount(qty);
        setTotalCost(Math.round(qty * (price + 0.012) * 1000) / 1000); // 0.012 = approx of account creation fees
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), mintCount = ref1[0], setMintCount = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(mintCount * (price + 0.012)), totalCost = ref2[0], setTotalCost = ref2[1];
    var ref3 = (0,_civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.useGateway)(), requestGatewayToken = ref3.requestGatewayToken, gatewayStatus = ref3.gatewayStatus;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), waitForActiveToken = ref4[0], setWaitForActiveToken = ref4[1];
    var previousGatewayStatus = usePrevious(gatewayStatus);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fromStates = [
            _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.GatewayStatus.NOT_REQUESTED,
            _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.GatewayStatus.REFRESH_TOKEN_REQUIRED, 
        ];
        var invalidToStates = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(fromStates).concat([
            _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.GatewayStatus.UNKNOWN
        ]);
        if (fromStates.find(function(state) {
            return previousGatewayStatus === state;
        }) && !invalidToStates.find(function(state) {
            return gatewayStatus === state;
        })) {
            setIsMinting(true);
        }
        console.log("change: ", _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.GatewayStatus[gatewayStatus]);
    }, [
        previousGatewayStatus,
        gatewayStatus,
        setIsMinting
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (waitForActiveToken && gatewayStatus === _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.GatewayStatus.ACTIVE) {
            console.log("Minting after token active");
            setWaitForActiveToken(false);
            onMint(mintCount);
        }
    }, [
        waitForActiveToken,
        gatewayStatus,
        onMint,
        mintCount
    ]);
    var disabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return loading || isSoldOut || isMinting || isEnded || !isActive || mintCount > limit;
    }, [
        loading,
        isSoldOut,
        isMinting,
        isEnded,
        !isActive
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        disabled: disabled,
        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("isActive gatekeeperNetwork", {
                            isActive: isActive,
                            gatekeeperNetwork: gatekeeperNetwork
                        });
                        if (!(isActive && gatekeeperNetwork)) return [
                            3,
                            5
                        ];
                        if (!(gatewayStatus === _civic_solana_gateway_react__WEBPACK_IMPORTED_MODULE_2__.GatewayStatus.ACTIVE)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onMint(mintCount)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        setWaitForActiveToken(true);
                        return [
                            4,
                            requestGatewayToken()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            onMint(mintCount)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                bold: true,
                color: "invertedContrast",
                children: [
                    "  ",
                    !candyMachine ? "CONNECTING..." : isSoldOut ? "SOLD OUT" : isActive ? mintCount > limit ? "LIMIT REACHED" : isMinting || loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}) : "Purchase Card Key" : isEnded ? "ENDED" : "UNAVAILABLE"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                ml: "4px",
                color: "invertedContrast"
            })
        ]
    });
};


/***/ }),

/***/ 24500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gl": function() { return /* binding */ candyMachineId; },
/* harmony export */   "L5": function() { return /* binding */ network; },
/* harmony export */   "Tb": function() { return /* binding */ candyMachineIdc2; },
/* harmony export */   "qW": function() { return /* binding */ candyMachineIdc3; }
/* harmony export */ });
/* unused harmony exports rpcHost, candyMachineIdc35, candyMachineIdc356 */
/* harmony import */ var _solana_wallet_adapter_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16247);
/* harmony import */ var _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59917);
/* provided dependency */ var process = __webpack_require__(34155);


var network = process.env.NEXT_PUBLIC_SOLANA_NETWORK || _solana_wallet_adapter_base__WEBPACK_IMPORTED_MODULE_1__/* .WalletAdapterNetwork.Devnet */ .Q.Devnet;
// const network = WalletAdapterNetwork.Devnet;
var rpcHost = (/* unused pure expression or super */ null && ("https://ssc-dao.genesysgo.net/" || 0));
var candyMachineId = new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(process.env.NEXT_PUBLIC_CANDY_MACHINE_ID || "4Eg728qPAkQ9cvBt4qM113ZmAvzpvRCs42HjWbQBoqka");
var candyMachineIdc2 = new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(process.env.NEXT_PUBLIC_CANDY_MACHINE_ID || "5nUsUk1QPFjegGsMaw4Vdbe74GERGr1wF9KpwvsDGyms");
var candyMachineIdc35 = new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(process.env.NEXT_PUBLIC_CANDY_MACHINE_ID || "3ygG9LHizQMTSWjKo2WyH8d8x94E8QVqFnVXK2pu5W8U");
var candyMachineIdc356 = new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(process.env.NEXT_PUBLIC_CANDY_MACHINE_ID || "4jWJnywHfBfpNrFbDFPKAy9644VqmGb2oKoLwZ7vd4kd");
var candyMachineIdc3 = new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(process.env.NEXT_PUBLIC_CANDY_MACHINE_ID || "F29LyXvW7gDDQzpxnMGZJ8SmcBjN5xqa1s65RWK29nLU"); // CtV2qDRtJgXXbB2L9nGDTMc3aYHoTujR4KCTLuwHnRQS
 // 9ipfnv13re3xh3iJ87As3LosJ5D8bh4BXsKnQJgqoj96
 // https://api.mainnet-beta.solana.com
 // https://metaplex.devnet.rpcpool.com/
 //6EEXUWCoEjeZMvohrvhXv96JkKN86HeaZrKrfhxLzguX


/***/ }),

/***/ 41748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MintCounterBorsh; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75815);
/* harmony import */ var borsh__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25532);
/* harmony import */ var borsh__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(borsh__WEBPACK_IMPORTED_MODULE_0__);


var MintCounterBorsh = /*#__PURE__*/ function() {
    "use strict";
    function MintCounterBorsh(args) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, MintCounterBorsh);
        Object.assign(this, args);
    }
    MintCounterBorsh.fromBuffer = function fromBuffer(buffer) {
        return (0,borsh__WEBPACK_IMPORTED_MODULE_0__.deserialize)(MintCounterBorsh.schema, MintCounterBorsh, buffer);
    };
    return MintCounterBorsh;
}();
MintCounterBorsh.schema = new Map([
    [
        MintCounterBorsh,
        {
            kind: "struct",
            fields: [
                //   ["accountDiscriminator", "Uint8Array"],
                [
                    "count",
                    "u16"
                ], 
            ]
        }, 
    ], 
]);


/***/ }),

/***/ 69269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VM": function() { return /* binding */ Hero; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* unused harmony exports StyledContainer, MintCount, Heading, MintButtonStyled, NftWrapper, NftWrapper2 */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  margin-right: auto;\n  margin-left: auto;\n  padding: 0 60px;\n  border-top: ",
        ";\n  @media only screen and (max-width: 1024px) {\n    max-width: calc(100% - 68px);\n    padding: 0 30px;\n  }\n\n  @media only screen and (max-width: 768px) {\n    max-width: calc(100% - 38px);\n    padding: 0 18px;\n  }\n\n  @media only screen and (max-width: 414px) {\n    max-width: 100%;\n    padding: 0 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  z-index: 99;\n  .cloud-content {\n    bottom: 0;\n    left: 0;\n    padding-top: 50px;\n    position: fixed;\n    right: 0;\n    top: 50px;\n    z-index: -1;\n  }\n\n  .cloud-block {\n    position: absolute;\n    opacity: 0.4;\n  }\n  .cloud-1 {\n    top: 50px;\n  }\n  .cloud-2 {\n    top: 40vh;\n  }\n  .cloud-3 {\n    top: 20vh;\n  }\n  .cloud-4 {\n    top: 40vh;\n  }\n  .cloud-5 {\n    top: 65vh;\n  }\n  .cloud-6 {\n    top: 35vh;\n  }\n  .cloud-7 {\n    bottom: 30px;\n  }\n\n  .cloud-1 {\n    animation: animate-1 32s linear infinite;\n    -webkit-animation: animate-1 83s linear infinite;\n    transform: scale(0.75);\n    -webkit-transform: scale(0.95);\n  }\n\n  .cloud-2 {\n    animation: animate-2 37s linear infinite;\n    -webkit-animation: animate-2 87s linear infinite;\n    transform: scale(0.45);\n    -webkit-transform: scale(0.45);\n  }\n\n  .cloud-3 {\n    animation: animate-3 45s linear infinite;\n    -webkit-animation: animate-3 85s linear infinite;\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n  }\n\n  .cloud-4 {\n    animation: animate-4 50s linear infinite;\n    -webkit-animation: animate-4 100s linear infinite;\n    transform: scale(0.8);\n    -webkit-transform: scale(0.2);\n  }\n\n  .cloud-5 {\n    animation: animate-5 55s linear infinite;\n    -webkit-animation: animate-5 105s linear infinite;\n    transform: scale(0.55);\n    -webkit-transform: scale(0.55);\n  }\n\n  .cloud-6 {\n    animation: animate-6 60s linear infinite;\n    -webkit-animation: animate-6 110s linear infinite;\n    transform: scale(0.85);\n    -webkit-transform: scale(0.85);\n  }\n\n  .cloud-7 {\n    animation: animate-7 65s linear infinite;\n    -webkit-animation: animate-7 115s linear infinite;\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n  }\n\n  /* Cloud Objects */\n\n  .cloud {\n    width: 350px;\n    height: 350px;\n    box-shadow: 0 16px 16px rgba(0, 0, 0, 0.1);\n    -webkit-box-shadow: 0 16px 16px rgba(0, 0, 0, 0.1);\n    position: relative;\n    background: url(/mf.png);\n    background-repeat: no-repeat;\n  }\n\n  // .cloud:after,\n  // .cloud:before {\n  //   background: #fff;\n  //   content: '';\n  //   position: absolute;\n  //   z-index: -1;\n  // }\n\n  // .cloud:after {\n  //   width: 100px;\n  //   height: 100px;\n  //   left: 50px;\n  //   top: -50px;\n  //   border-radius: 100px;\n  // }\n\n  // .cloud:before {\n  //   width: 180px;\n  //   height: 180px;\n  //   right: 50px;\n  //   top: -90px;\n  //   border-radius: 200px;\n  // }\n\n  /* KEYFRAMES */\n\n  @keyframes animate-1 {\n    0% {\n      left: 90%;\n    }\n    10% {\n      left: 110%;\n    }\n    10.001% {\n      left: -10%;\n    }\n    100% {\n      left: 90%;\n    }\n  }\n\n  @keyframes animate-2 {\n    0% {\n      left: 75%;\n    }\n    25% {\n      left: 110%;\n    }\n    25.001% {\n      left: -10%;\n    }\n    100% {\n      left: 75%;\n    }\n  }\n\n  @keyframes animate-3 {\n    0% {\n      left: 60%;\n    }\n    40% {\n      left: 110%;\n    }\n    40.001% {\n      left: -10%;\n    }\n    100% {\n      left: 60%;\n    }\n  }\n\n  @keyframes animate-4 {\n    0% {\n      left: 45%;\n    }\n    55% {\n      left: 110%;\n    }\n    55.001% {\n      left: -10%;\n    }\n    100% {\n      left: 45%;\n    }\n  }\n\n  @keyframes animate-5 {\n    0% {\n      left: 30%;\n    }\n    70% {\n      left: 110%;\n    }\n    70.001% {\n      left: -10%;\n    }\n    100% {\n      left: 30%;\n    }\n  }\n\n  @keyframes animate-6 {\n    0% {\n      left: 10%;\n    }\n    90% {\n      left: 110%;\n    }\n    90.001% {\n      left: -10%;\n    }\n    100% {\n      left: 10%;\n    }\n  }\n\n  @keyframes animate-7 {\n    0% {\n      left: -10%;\n    }\n\n    99.99% {\n      left: 110%;\n    }\n    100% {\n      left: -10%;\n    }\n  }\n\n  /* ANIMATIONS */\n\n  .sun {\n    margin: 0px auto;\n    width: 170px;\n    height: 170px;\n    border-radius: 100%;\n    background-color: #fcc952;\n    background-image: linear-gradient(\n      145deg,\n      rgba(252, 201, 82, 1) 0%,\n      rgba(252, 201, 82, 1) 61%,\n      rgba(248, 160, 55, 1) 100%\n    );\n    -webkit-background-image: linear-gradient(\n      145deg,\n      rgba(252, 201, 82, 1) 0%,\n      rgba(252, 201, 82, 1) 61%,\n      rgba(248, 160, 55, 1) 100%\n    );\n    box-shadow: inset 2px 2px 8px 0 rgba(252, 201, 82, 0),\n      inset -3px -3px 8px 0 rgba(245, 169, 76, 0),\n      6px 6px 18px 0 rgba(204, 123, 35, 0.35),\n      -6px -6px 18px 0 rgba(205, 157, 35, 0.5);\n    -webkit-box-shadow: inset 2px 2px 8px 0 rgba(252, 201, 82, 0),\n      inset -3px -3px 8px 0 rgba(245, 169, 76, 0),\n      6px 6px 18px 0 rgba(204, 123, 35, 0.35),\n      -6px -6px 18px 0 rgba(205, 157, 35, 0.5);\n    position: relative;\n    z-index: 2;\n  }\n  .sunlight-content {\n    bottom: 0;\n    left: 50%;\n    position: fixed;\n    right: 0;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    width: max-content;\n    height: max-content;\n  }\n  .sun-face {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n  }\n  .eyes-block {\n    width: 80px;\n    display: flex;\n    display: -webkit-flex;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n  }\n  .eyes {\n    background-color: #2e261a;\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    display: inline-flex;\n    display: -webkit-inline-flex;\n    position: relative;\n  }\n  .eyes:before {\n    content: '';\n    height: 6px;\n    width: 6px;\n    display: block;\n    position: absolute;\n    top: 3px;\n    background-color: #fff;\n    border-radius: 100%;\n    animation: Rotate-eye 4s ease-in-out alternate infinite;\n    -webkit-animation: Rotate-eye 4s ease-in-out alternate infinite;\n  }\n  .mouth {\n    width: 18px;\n    height: 18px;\n    background-color: #2f261a;\n    text-align: center;\n    margin: 0px auto;\n    position: absolute;\n    overflow: hidden;\n    border-radius: 0px 0px 25px 25px;\n    left: 50%;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    top: 100%;\n    animation: scale-mouth 2s linear infinite;\n    -webkit-animation: scale-mouth 2s linear infinite;\n  }\n  .tongue {\n    width: 100%;\n    height: 16px;\n    background-color: #f54b2e;\n    border-radius: 100%;\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n    animation: scale-tongue 2s linear infinite;\n    -webkit-animation: scale-tongue 2s linear infinite;\n  }\n\n  .sunlight-box {\n    filter: drop-shadow(0px 0px 12px rgba(252, 201, 82, 0.8));\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: Rotate 20s linear infinite;\n    -webkit-animation: Rotate 20s linear infinite;\n  }\n  .sunlight-box span {\n    height: 170px;\n    width: 170px;\n    background-color: #f8a037;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: 1;\n  }\n  .sunlight-box span:first-child {\n    transform: rotate(30deg);\n    -webkit-transform: rotate(30deg);\n  }\n  .sunlight-box span:nth-child(2) {\n    transform: rotate(60deg);\n    -webkit-transform: rotate(60deg);\n  }\n  .sunlight-box span:nth-child(3) {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n  }\n\n  /* keyframe animation */\n  @keyframes Rotate {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  @-webkit-keyframes Rotate {\n    from {\n      -webkit-transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes Rotate-eye {\n    0%,\n    35% {\n      right: 3px;\n    }\n    65%,\n    100% {\n      right: 10px;\n    }\n  }\n\n  @-webkit-keyframes Rotate-eye {\n    0%,\n    35% {\n      right: 3px;\n    }\n    65%,\n    100% {\n      right: 10px;\n    }\n  }\n\n  @keyframes scale-mouth {\n    0% {\n      height: 18px;\n    }\n\n    100% {\n      height: 24px;\n    }\n  }\n\n  @-webkit-keyframes scale-mouth {\n    0% {\n      height: 18px;\n    }\n\n    100% {\n      height: 24px;\n    }\n  }\n\n  @keyframes scale-tongue {\n    0% {\n      height: 16px;\n    }\n\n    100% {\n      height: 20px;\n    }\n  }\n\n  @-webkit-keyframes scale-tongue {\n    0% {\n      height: 16px;\n    }\n\n    100% {\n      height: 20px;\n    }\n  }\n\n  /* Responsive media query */\n  @media screen and (max-width: 767px) {\n    .sun {\n      width: 140px;\n      height: 140px;\n    }\n    .sunlight-box span {\n      height: 140px;\n      width: 140px;\n    }\n    .cloud {\n      width: 150px;\n      height: 260px;\n    }\n    // .cloud:before {\n    //   width: 120px;\n    //   height: 120px;\n    //   top: -80px;\n    //   right: 50px;\n    // }\n    .eyes-block {\n      width: 70px;\n    }\n    .eyes {\n      width: 18px;\n      height: 18px;\n    }\n    .eyes:before {\n      height: 5px;\n      width: 5px;\n    }\n    .mouth {\n      width: 15px;\n      height: 15px;\n    }\n    .tongue {\n      bottom: -8px;\n    }\n    /* KEYFRAMES */\n\n    @keyframes scale-mouth {\n      0% {\n        height: 15px;\n      }\n\n      100% {\n        height: 22px;\n      }\n    }\n\n    @-webkit-keyframes scale-mouth {\n      0% {\n        height: 15px;\n      }\n\n      100% {\n        height: 22px;\n      }\n    }\n\n    @keyframes scale-tongue {\n      0% {\n        height: 14px;\n      }\n\n      100% {\n        height: 20px;\n      }\n    }\n\n    @-webkit-keyframes scale-tongue {\n      0% {\n        height: 14px;\n      }\n\n      100% {\n        height: 20px;\n      }\n    }\n\n    .cloud-1 {\n      animation: animate-1 32s linear infinite;\n      -webkit-animation: animate-1 43s linear infinite;\n      transform: scale(0.45);\n      -webkit-transform: scale(0.45);\n    }\n\n    .cloud-2 {\n      animation: animate-2 37s linear infinite;\n      -webkit-animation: animate-2 47s linear infinite;\n      transform: scale(0.25);\n      -webkit-transform: scale(0.25);\n    }\n\n    .cloud-3 {\n      animation: animate-3 45s linear infinite;\n      -webkit-animation: animate-3 45s linear infinite;\n      transform: scale(0.3);\n      -webkit-transform: scale(0.3);\n    }\n\n    .cloud-4 {\n      animation: animate-4 50s linear infinite;\n      -webkit-animation: animate-4 60s linear infinite;\n      transform: scale(0.6);\n      -webkit-transform: scale(0.6);\n    }\n\n    .cloud-5 {\n      animation: animate-5 55s linear infinite;\n      -webkit-animation: animate-5 65s linear infinite;\n      transform: scale(0.45);\n      -webkit-transform: scale(0.45);\n    }\n\n    .cloud-6 {\n      animation: animate-6 60s linear infinite;\n      -webkit-animation: animate-6 70s linear infinite;\n      transform: scale(0.55);\n      -webkit-transform: scale(0.55);\n    }\n\n    .cloud-7 {\n      animation: animate-7 65s linear infinite;\n      -webkit-animation: animate-7 75s linear infinite;\n      transform: scale(0.3);\n      -webkit-transform: scale(0.3);\n    }\n\n    .marquee {\n      -webkit-animation-duration: 30s;\n      animation-duration: 30s;\n    }\n  }\n\n  // .wallet-adapter-modal-wrapper {\n  //   background: #ffffff;\n  // }\n\n  // .wallet-adapter-button {\n  //   background-color: #000000;\n  // }\n\n  // .wallet-adapter-modal-list {\n  //   margin: 0 0 4px !important;\n  // }\n  // .wallet-adapter-modal-list li:not(:first-of-type) {\n  //   margin-top: 4px !important;\n  // }\n\n  // .wallet-adapter-modal-title {\n  //   color: #000000;\n  // }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin: 0px 0 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'Patrick Hand', cursive;\n  font-size: 30px;\n  line-height: 1;\n  margin-bottom: 20px;\n  margin-top: 25px;\n  font-weight: 700;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: nabana;\n  letter-spacing: 2px;\n  margin-bottom: -20px;\n  color: #897ea5;\n  font-size: 60px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 0.1px solid #424242;\n  background: #000000b0;\n  border-radius: 10px;\n  padding: 6px;\n  font-size: 28px;\n  min-width: 300px;\n  box-shadow: 2px 3px 1px 0px #fff;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n\n  :hover {\n    background: #0000;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  z-index: 99;\n  .marquee-wrapper {\n    overflow: hidden;\n    transform: skew(360deg, 356deg);\n  }\n\n  .marquee {\n    display: flex;\n    animation-name: marquee;\n    animation-duration: 50s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n    animation-direction: alternate;\n    transform: translateX(0);\n    img {\n      padding: 5px;\n      max-width: 200px;\n      border-radius: 10px;\n    }\n  }\n\n  @keyframes marquee {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(-100%);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  z-index: 99;\n  .marquee-wrapper {\n    overflow: hidden;\n    transform: skew(360deg, 356deg);\n  }\n\n  .marquee {\n    display: flex;\n    animation-name: marquee2;\n    animation-duration: 50s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n    animation-direction: alternate;\n    transform: translateX(0);\n\n    img {\n      padding: 5px;\n      max-width: 200px;\n      border-radius: 10px;\n    }\n  }\n\n  @keyframes marquee2 {\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("div").withConfig({
    componentId: "sc-b6f9112a-0"
})(_templateObject(), function(p) {
    return p.border ? "1px solid #CDD1D4" : "";
});
var Root = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("div").withConfig({
    componentId: "sc-b6f9112a-1"
})(_templateObject1());
var Hero = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("div").withConfig({
    componentId: "sc-b6f9112a-2"
})(_templateObject2());
var MintCount = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("h3").withConfig({
    componentId: "sc-b6f9112a-3"
})(_templateObject3());
var Heading = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("h1").withConfig({
    componentId: "sc-b6f9112a-4"
})(_templateObject4());
var MintButtonStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("button").withConfig({
    componentId: "sc-b6f9112a-5"
})(_templateObject5());
var NftWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("div").withConfig({
    componentId: "sc-b6f9112a-6"
})(_templateObject6());
var NftWrapper2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])("div").withConfig({
    componentId: "sc-b6f9112a-7"
})(_templateObject7());


/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = /* unused reexport */ __webpack_require__(62587);
__webpack_unused_export__ = exports.stringify = __webpack_require__(12361);


/***/ }),

/***/ 43094:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 80950:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 89214:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 85568:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 29120:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 46586:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 73105:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 65308:
/***/ (function() {

/* (ignored) */

/***/ })

}]);